module.exports = __webpack_public_path__ + "img/INTERIOR-SCROSS-5.72c643e9.jpg";